import { useQuery } from '@tanstack/react-query'
import { getTemplatesVersions } from '../../permit-template/api/permit-template-api'

export const templateVersionsQueryOptions = (
  cityId: string | undefined,
  search = '',
  enabled = true,
) => ({
  queryKey: ['template-versions', cityId ?? '', search] as const,
  queryFn: () => getTemplatesVersions(search),
  enabled: Boolean(cityId) && enabled,
})

export const checklistTemplatesQueryOptions = (
  cityId: string | undefined,
  enabled = true,
) => templateVersionsQueryOptions(cityId, '', enabled)

export const useChecklistTemplates = (
  cityId: string | undefined,
  search = '',
  enabled = true,
) => {
  const { data, isLoading } = useQuery({
    ...templateVersionsQueryOptions(cityId, search, enabled),
    placeholderData: (prev) => prev,
  })
  return { templates: data ?? [], isLoading }
}
